import { getRepaymentList } from '../../api/api'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import { RECEIVE_REPAYMENT_HISTORY } from './repayments'

// action types
export const REQUEST_REPAYMENT_LIST = 'rp/repayment/REQUEST_REPAYMENT_LIST'
export const RECEIVE_REPAYMENT_LIST = 'rp/repayment/RECEIVE_REPAYMENT_LIST'

// action creators
export const requestRepaymentsList = () => ({
  type: REQUEST_REPAYMENT_LIST,
})

export const receiveRepaymentsList = payload => ({
  type: RECEIVE_REPAYMENT_LIST,
  payload,
})

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_REPAYMENT_LIST:
      return { ...state, ...payload }
    case RECEIVE_REPAYMENT_HISTORY:
      return {
        ...state,
        [payload.planId]: {
          ...state[payload.planId],
          payments: payload.payments.map(({ id }) => id),
        },
      }
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// sagas
function* getRepaymentsList() {
  const { repayments } = yield call(getRepaymentList)
  // get list of existing plans, in case payment history already added
  const plans = yield select(({ repaymentPlans }) => repaymentPlans)

  if (repayments.length) {
    yield put({
      type: RECEIVE_REPAYMENT_LIST,
      payload: repayments.reduce(
        (obj, repayment) => ({
          ...obj,
          [repayment.id]: {
            // merge in payment history if it exists
            ...(plans[repayment.id] || {}),
            ...repayment,
          },
        }),
        {},
      ),
    })
  }
}

function* watchRequestRepayments() {
  yield takeLatest(
    REQUEST_REPAYMENT_LIST,
    createRequestSaga(getRepaymentsList, {
      key: 'payments',
      message: __('Looking up repayments'),
    }),
  )
}

export const sagas = [watchRequestRepayments]
